module.exports = __webpack_public_path__ + "img/hot-dog.97ceda2c.svg";